module.exports = __webpack_public_path__ + "img/right-hand.44d421e5.svg";